const getRole = () => localStorage.getItem('role');

export const isProviderRole = () => {
  const role = getRole();
  return role === "Provider Admin" || role === "Provider";
};

export const isBillerOrFrontDesk = () => {
  const role = getRole();
  return role === "Biller" || role === "Front Desk";
};
